/* eslint-disable react-hooks/exhaustive-deps */
import {
    AssignmentReturnOutlined,
    CheckCircle,
    Clear,
    Delete,
    Edit,
    Search,
    RequestQuote,
    Done,
    Report,
    ReplayOutlined,
} from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Tooltip, Typography } from "@mui/material";
import {
    GridActionsCellItem,
    GridRowId,
    GridRowModel,
    GridRowParams,
    GridRowSelectionModel,
    GridSortDirection,
    GridSortModel,
} from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
import TextInput from "../../../components/hookForms/textField";
import DataTable from "../../../components/dataTable";
import DatePickerMui from "../../../components/hookForms/datePicker";
import DialogApproveById from "./modal/dialogApproveById";
import DialogConfirm from "../../../components/confirmationDialog";
import DialogEdit from "./modal/dialogEdit";
import DialogInfo from "./modal/dialogInfo";
import DialogError from "./modal/dialogError";
import DialogReopen from "./modal/dialogReopen";
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import { format } from "date-fns";
import serviceFaturaSaldoChurn from "../../../services/serviceFaturaSaldoChurn";
import serviceConcessionaria from "../../../services/serviceConcessionaria";
import serviceUsina from "../../../services/serviceUsina";
import { toast } from "react-toastify";
import useThrowAsyncError from "@/hooks/useThrowAsyncError";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import DialogRecalculate from "./modal/dialogRecalculate";
import FiltersSelect from './modal/filtersSelect'

const FaturaSaldoChurn = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Cobrança Saldo Churn - Cobrança de Saldo Churn");
    }, [setTitlePage]);

    const [rowCount, setRowCount] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState(null);
    const [page, setPage] = useState(0);
    const [disableButtonPublishActive, setDisableButtonPublishActive] = useState(0);
    const [disablePublishAllButton, setDisablePublishAllButton] = useState(false);
    const [isPublish, setIsPublish] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [openDate, closeDate] = useState(false)
    const [aprovarLoteDisabled, setAprovarLoteDisabled] = useState(false);
    const [gerarCobrancaDisabled, setGerarCobrancaDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [approveById, setApproveById] = useState(false);
    const [linesSelecteds, setLinesSelecteds] = useState<GridRowSelectionModel>([]);
    const [valueId, setValueId] = useState<any>();
    const [openRecalculateDialog, setOpenRecalculateDialog] = useState(false);
    const [recalculateId, setRecalculateId] = useState<any>();
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [discardState, setDiscardState] = useState({ data: "", open: false });
    const [errorState, setErrorState] = useState({ open: false, id: "" });
    const [reopen, setReopen] = useState(false);
    const [buttonSelected, setButtonSelected] = useState<any[]>(["Aberto"]);
    const [dataMessages, setDataMessages] = useState<string[]>([]);
    const [infoModal, setInfoModal] = useState(false);
    const classes = useStyles();

    const [editState, setEditState] = useState({
        open: false,
        id: "",
        tarifaCobrada: "",
        saldoNaoPago: "",
        numeroInstalacao: "",
        nomeUsina: "",
    });

    const publishMessage = {
        multiple: `Tem certeza que deseja publicar todas as ${linesSelecteds.length} cobranças selecionadas?`,
        simple: "Tem certeza que deseja publicar a cobrança selecionada?",
    };

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            cicloFaturamento: null,
            usinaID: 0,
            numeroInstalacao: "",
            nomeCliente: "",
            codigoExternoCliente: "",
            statusFaturaChurn: "Aberto",
            concessionariaID: 0,
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 260,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                tarifaCobrada: params.row.tarifaCobrada,
                                saldoNaoPago: params.row.saldoNaoPago,
                                nomeUsina: params.row.nomeUsina,
                                numeroInstalacao: params.row.numeroInstalacao,
                            })
                        }
                        disabled={params.row.statusFaturaChurn !== "Aberto"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Aprovar">
                                <CheckCircle />
                            </Tooltip>
                        }
                        label="Aprovar"
                        onClick={() => {
                            handleApproveById(params.id, params.row.numeroInstalacao, params.row.cicloFaturamento);
                        }}
                        disabled={params.row.statusFaturaChurn !== "Aberto" || aprovarLoteDisabled}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Publicar">
                                <Done />
                            </Tooltip>
                        }
                        label="Publicar"
                        onClick={() => {
                            handlePublish(params.id);
                        }}
                        disabled={
                            params.row.statusFaturaChurn === "Aberto" ||
                            params.row.statusFaturaChurn === "Aguardando Publicação" ||
                            params.row.statusFaturaChurn === "Publicado" ||
                            params.row.statusFaturaChurn === "Descartado" ||
                            params.id === disableButtonPublishActive
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Descartar">
                                <Delete />
                            </Tooltip>
                        }
                        label="Descartar"
                        onClick={() => setDiscardState({ data: params.id.toString(), open: true })}
                        disabled={
                            params.row.statusFaturaChurn !== "Aberto" && params.row.statusFaturaChurn !== "Aprovado"
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Reabrir">
                                <AssignmentReturnOutlined />
                            </Tooltip>
                        }
                        label="Reabrir"
                        onClick={() =>
                            handleReopen(params.id, params.row.numeroInstalacao, params.row.cicloFaturamento)
                        }
                        disabled={params.row.statusFaturaChurn === "Aberto"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Recalcular">
                                <ReplayOutlined />
                            </Tooltip>
                        }
                        label="Recalcular"
                        onClick={() => handleRecalculate(params.id)}
                        disabled={params.row.statusFaturaChurn !== "Aberto"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Erros">
                                <Report />
                            </Tooltip>
                        }
                        label="Erros"
                        onClick={async () => {
                            setErrorState({
                                open: true,
                                id: params.id.toString(),
                            });
                        }}
                        disabled={params.row.statusFaturaChurn !== "Erro"}
                    />,
                ],
            },
        ],
        [filters]
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "faturaSaldoChurnID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Ciclo",
                field: "cicloFaturamento",
                type: "string",
                width: 80,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                width: 250,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                width: 180,
            },
            {
                headerName: "Cliente",
                field: "nomeCliente",
                type: "string",
                width: 250,
            },
            {
                headerName: "Cota (kWh)",
                field: "cotaKwh",
                type: "number",
                headerAlign: "left",
                width: 120,
            },
            {
                headerName: "Saldo Não Pago (kWh)",
                field: "saldoNaoPago",
                type: "number",
                headerAlign: "left",
                width: 180,
            },
            {
                headerName: "Tarifa (R$)",
                field: "tarifaCobrada",
                type: "number",
                headerAlign: "left",
                width: 120,
            },
            {
                headerName: "Lançamentos (R$)",
                field: "valorLancamentos",
                type: "number",
                headerAlign: "left",
                width: 140,
            },
            {
                headerName: "Valor Cobrado (R$)",
                field: "valorCobrado",
                type: "number",
                headerAlign: "left",
                width: 160,
            },
            {
                headerName: "Status",
                field: "statusFaturaChurn",
                type: "string",
                width: 140,
            },
            {
                headerName: "Data Publicação",
                field: "dataPublicacao",
                type: "string",
                width: 130,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setUsinaData();
    }, []);

    const handleRecalculate = (id: any) => {
        setOpenRecalculateDialog(true);
        setRecalculateId(id);
    };

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const statusOptions = [
        { label: "Aberto", value: "Aberto" },
        { label: "Aprovado", value: "Aprovado" },
        { label: "Aguardando Publicação", value: "Aguardando Publicação" },
        { label: "Publicado", value: "Publicado" },
        { label: "Descartado", value: "Descartado" },
        { label: "Erro", value: "Erro" },
    ];

    const handleApproveById = (id: any, numeroInstalacao: any, cicloFaturamento: any) => {
        setApproveById(true);
        setValueId({ id, numeroInstalacao, cicloFaturamento });
    };

    const throwAsyncError = useThrowAsyncError();

    const getAllWithFilters = async (filters: any) => {
        setLoading(true);
        setData([]);

        if (!filters) {
            filters = { statusFaturaChurn: "Aberto" };
        }

        serviceFaturaSaldoChurn
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                if (!result) {
                    throw new Error("Falha ao carregar os dados.");
                }
                setData(result.data.content);
                setRowCount(result.data.numberOfElements);
            })
            .catch((err) => {
                setData([]);
                setRowCount(0);
                throwAsyncError(err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const onClear = () => {
        setButtonSelected(["Aberto"]);
        reset({ statusFaturaChurn: "Aberto" });
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            cicloFaturamento: values.cicloFaturamento ? format(values.cicloFaturamento, "MM/yyyy") : "",
            statusFaturaChurn: buttonSelected.join(","),
            usinaID: values.usinaID ? Number(values.usinaID) : "",
            concessionariaID: values.concessionariaID ? Number(values.concessionariaID) : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const handleDiscard = async () => {
        serviceFaturaSaldoChurn
            .discard(discardState.data)
            .then((result) => {
                if (result) {
                    toast.success("Registro descartado com sucesso!");
                }
            })
            .catch((err) => {
                toast.error("Ocorreu um erro ao descartar o registro!", err);
            })
            .finally(() => {
                setDiscardState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    const handleApproveMany = () => {
        setAprovarLoteDisabled(true);
        setLoading(true);

        const selecteds = data.filter((item) => linesSelecteds.includes(item.faturaSaldoChurnID));

        let arrayMenssages: string[] = [];
        let listIds: number[] = [];

        if (selecteds.length > 0) {
            // eslint-disable-next-line array-callback-return
            selecteds.map((value) => {
                if (value.statusFaturaChurn === "Aberto") {
                    listIds.push(value.faturaSaldoChurnID);
                } else {
                    arrayMenssages.push(
                        `A cobrança para instalação ${value.numeroInstalacao} - ID: ${value.faturaSaldoChurnID} não pode ser aprovada.`
                    );
                }
            });
        }

        if (arrayMenssages.length > 0) {
            setDataMessages(arrayMenssages);
            setAprovarLoteDisabled(false);
            setLoading(false);
            return;
        }

        const newValues = {
            faturasIds: listIds.length >= 0 ? listIds.join(", ") : "",
        };

        serviceFaturaSaldoChurn
            .approveMany(newValues)
            .then((result) => {
                if (result) {
                    getAllWithFilters(filters);
                    toast.success("Cobranças aprovadas com sucesso!");
                }
            })
            .catch((err) => {
                toast.error("Ocorreu um erro e não foi possível aprovar as cobranças selecionadas", err);
            })
            .finally(() => {
                setAprovarLoteDisabled(false);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (dataMessages.length > 0) setInfoModal(true);
    }, [dataMessages]);

    const handlePublish = async (id?: any) => {
        setDisableButtonPublishActive(id);
        setDisablePublishAllButton(true);
        setLoading(true);

        const selecteds = data.filter((item) => linesSelecteds.includes(item.faturaSaldoChurnID));

        let arrayMenssages: string[] = [];
        let listIds: number[] = [];

        if (selecteds.length > 0) {
            // eslint-disable-next-line array-callback-return
            selecteds.map((value) => {
                if (value.statusFaturaChurn === "Aprovado" || value.statusFaturaChurn === "Erro") {
                    listIds.push(value.faturaSaldoChurnID);
                } else {
                    arrayMenssages.push(
                        `A cobrança para instalação ${value.numeroInstalacao} - ID: ${value.faturaSaldoChurnID} não pode ser publicada.`
                    );
                }
            });
        }

        if (arrayMenssages.length > 0) {
            setDataMessages(arrayMenssages);
            setDisablePublishAllButton(false);
            setLoading(false);
            return;
        }

        let dataId = {};

        if (id) {
            dataId = { ids: id.toString() };
        } else {
            dataId = { ids: listIds.length >= 0 ? listIds.join() : "" };
        }

        serviceFaturaSaldoChurn
            .publish(dataId)
            .then((result) => {
                if (result && result.status === 200) {
                    toast.info("A publicação da(s) cobrança(s) será realizada, por favor aguarde.");
                    getAllWithFilters(filters);
                }
            })
            .catch((err) => {
                toast.error("Ocorreu um erro ao realizar a publicação da(s) cobrança(s)!", err);
            })
            .finally(() => {
                setDisableButtonPublishActive(0);
                setDisablePublishAllButton(false);
                setLoading(false);
            });
    };

    const handleReopen = (id: any, numeroInstalacao: any, cicloFaturamento: any) => {
        setReopen(true);
        setValueId({ id, numeroInstalacao, cicloFaturamento });
    };

    const handleDatas = () => {
        closeDate(() => !openDate)
    }

    const handleGenerateWithFilters = async (dataInicio: string, dataFim: string, idsConcessionarias: string = "") => {
        setLoading(true);
        setGerarCobrancaDisabled(true);

        const dates = {
            CicloInicio: dataInicio,
            CicloFim: dataFim,
            IdsConcessionarias: idsConcessionarias
        };

        serviceFaturaSaldoChurn
            .generate(dates)
            .then((result) => {
                if (result && result.status === 200) {
                    if (result && result.data?.qtdeInstalacoes && result.data?.qtdeInstalacoes > 0) {
                        toast.info(
                            "Quantidade de cobranças a serem geradas: " +
                            result.data?.qtdeInstalacoes +
                            ". Por favor aguarde..."
                        );
                    } else {
                        toast.info("Não foram encontradas instalações com cobrança a ser gerada!");
                    }
                }
            })
            .finally(() => {
                setLoading(false);
                setGerarCobrancaDisabled(false);
            });
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item md={2}>
                                    <DatePickerMui
                                        name="cicloFaturamento"
                                        label="Ciclo"
                                        format="MM/yyyy"
                                        view={["month", "year"]}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={3}>
                                    <InputNumber
                                        name="numeroInstalacao"
                                        label="Instalação"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={15}
                                    />
                                </Grid>

                                <Grid item md={3}>
                                    <AutoComplete
                                        name="usinaID"
                                        label="Nome da usina"
                                        options={usinaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={2}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        color="warning"
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<Search />}
                                        type="submit"
                                        disabled={isLoading}
                                        disableElevation
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>

                                <Grid item md={2}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<RequestQuote />}
                                        disableElevation
                                        onClick={() => handleDatas()}
                                        disabled={gerarCobrancaDisabled}
                                    >
                                        Gerar Cobrança
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item md={2}>
                                    <TextInput
                                        name="codigoExternoCliente"
                                        label="Código externo"
                                        control={control}
                                        error={errors}
                                        maxLength={20}
                                    />
                                </Grid>

                                <Grid item md={3}>
                                    <TextInput name="nomeCliente" label="Cliente" control={control} error={errors} />
                                </Grid>

                                <Grid item md={3}>
                                    <AutoComplete
                                        name="concessionariaID"
                                        label="Nome da concessionária"
                                        options={concessionariaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2} display="flex" alignItems="center">
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="outlined"
                                        color="warning"
                                        startIcon={<Clear />}
                                        onClick={() => onClear()}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Limpar
                                    </Button>
                                </Grid>

                                <Grid item md={1}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<CheckCircle />}
                                        onClick={() => handleApproveMany()}
                                        disableElevation
                                        disabled={aprovarLoteDisabled || linesSelecteds.length <= 0}
                                    >
                                        Aprovar
                                    </Button>
                                </Grid>

                                <Grid item md={1}>
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<Done />}
                                        onClick={() => {
                                            setIsPublish(true);
                                        }}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                        disabled={disablePublishAllButton || linesSelecteds.length <= 0}
                                    >
                                        Publicar
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container display="flex" alignItems="center">
                                <Grid item sx={{ mt: 2 }}>
                                    <Typography variant="subtitle2" color="#5B5B5F">
                                        Status:
                                        {statusOptions.map((item, index) => {
                                            return (
                                                <Button
                                                    key={index}
                                                    variant={
                                                        buttonSelected.includes(item.value) ? "contained" : "outlined"
                                                    }
                                                    color="warning"
                                                    size="small"
                                                    disableElevation
                                                    onClick={() => {
                                                        setButtonSelected((oldstate) => {
                                                            if (oldstate.includes(item.value)) {
                                                                return oldstate.filter((e) => e !== item.value);
                                                            } else {
                                                                return [...oldstate, item.value];
                                                            }
                                                        });
                                                    }}
                                                    style={{ margin: "0px 12px", minWidth: "120px", height: "33px" }}
                                                >
                                                    {item.label}
                                                </Button>
                                            );
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.faturaSaldoChurnID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                            checkboxSelection
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setLinesSelecteds(newSelectionModel);
                            }}
                            rowSelectionModel={linesSelecteds}
                            getRowClassName={(params: GridRowParams<GridRowModel>) => {
                                if (
                                    params.row.statusFaturaChurn === "Aberto" &&
                                    params.row.clienteInstalacaoAtiva === "Não"
                                )
                                    return classes.amarelo;
                            }}
                        />
                    </Box>

                    <DialogApproveById
                        open={approveById}
                        clearDataTable={() => {
                            getAllWithFilters(filters);
                        }}
                        idProp={valueId}
                        onClose={() => setApproveById(false)}
                    />

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            tarifaCobrada: editState.tarifaCobrada,
                            saldoNaoPago: editState.saldoNaoPago,
                            nomeUsina: editState.nomeUsina,
                            numeroInstalacao: editState.numeroInstalacao,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                tarifaCobrada: "",
                                saldoNaoPago: "",
                                numeroInstalacao: "",
                                nomeUsina: "",
                            });
                        }}
                    />

                    <DialogConfirm
                        open={discardState?.open}
                        title={"Descartar"}
                        message={"Deseja realmente descartar o registro?"}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setDiscardState({ data: "", open: false })}
                        onCancel={() => setDiscardState({ data: "", open: false })}
                        onConfirm={() => {
                            setDiscardState({ data: "", open: false });
                            handleDiscard();
                        }}
                    />

                    <DialogConfirm
                        open={isPublish}
                        title={"Publicar cobranças pendentes?"}
                        message={linesSelecteds.length > 1 ? publishMessage.multiple : publishMessage.simple}
                        cancelButtonText={"Cancelar"}
                        confirmButtonText={"Confirmar"}
                        onClose={() => setIsPublish(false)}
                        onCancel={() => setIsPublish(false)}
                        onConfirm={() => {
                            setIsPublish(false);
                            handlePublish();
                        }}
                    />

                    <DialogError
                        open={errorState.open}
                        data={{
                            open: errorState.open,
                            id: errorState.id,
                        }}
                        onClose={() => {
                            setErrorState({ open: false, id: "" });
                        }}
                    />

                    <DialogReopen
                        open={reopen}
                        idProp={valueId}
                        onClose={() => {
                            setReopen(false);
                            getAllWithFilters(filters);
                        }}
                        onCancel={() => {
                            setReopen(false);
                        }}
                    />

                    <DialogRecalculate
                        open={openRecalculateDialog}
                        data={recalculateId}
                        onClose={() => setOpenRecalculateDialog(false)}
                        onSuccess={() => onSuccessAction()}
                    />
                </CardContent>
            </Card>

            {infoModal && (
                <DialogInfo
                    data={dataMessages}
                    onClose={() => {
                        setInfoModal(false);
                        setDataMessages([]);
                    }}
                />
            )}
            {openDate && (
                <FiltersSelect 
                    open={openDate} 
                    onClose={() => closeDate(false)} 
                    onConfirm={handleGenerateWithFilters}
                />
            )}
        </Container>
    );
};

const useStyles = makeStyles({
    amarelo: {
        backgroundColor: "#FAF8B4",
        "&:hover": {
            backgroundColor: "#f4f066 !important",
        },
    },
    vermelho: {
        backgroundColor: "#FFA0A3",
        "&:hover": {
            backgroundColor: "#ff6b6f !important",
        },
    },
});

export default FaturaSaldoChurn;
